enum UploadActuals {
  UPLOAD_ACTUALS = 'upload-actuals',
  IMPORT_ACTUALS_STATUS = 'upload-actuals/status'
}

export default UploadActuals;
